import Styles from './MobileButton.module.scss'
import { useObjectRef } from '@react-aria/utils'
import { forwardRef, PropsWithChildren } from 'react'
import { MobileButtonProps, MobileButtonSize } from './Types'
import { useButton } from '@react-aria/button'
import cx from 'classnames'

const iconSize: Record<MobileButtonSize, number> = {
  sm: 20,
  md: 28,
}

export const MobileButton = forwardRef<HTMLButtonElement, PropsWithChildren<MobileButtonProps>>(
  ({ children, icon: Icon, variant = 'primary', size = 'md', ...props }, fRef) => {
    const ref = useObjectRef(fRef)
    const { buttonProps } = useButton(props, ref)
    return (
      <button {...buttonProps} className={cx(Styles.mobileButton, Styles[variant], Styles[size])} ref={ref}>
        <Icon size={iconSize[size]} />
        {children}
      </button>
    )
  },
)
